import { render } from "../templates/scenario-benefits.html?vue&type=template&id=4f7c2788&scoped=true"
import script from "./scenario-benefits.vue?vue&type=script&lang=js"
export * from "./scenario-benefits.vue?vue&type=script&lang=js"

import "./scenario-benefits.vue?vue&type=style&index=0&id=4f7c2788&lang=scss&scoped=true"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c2788"]])

export default __exports__